import React, { PropTypes } from 'react'
import { Link, withRouter } from 'react-router'

import styles from './AnswerItem.css'

const numberMapChar = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

function AnswerItem ({
  index,
  question,
  answer,
  userAnswer,
  category,
  location: { query },
  params: { exam }
}, {
  openConsult
}) {

  const { from } = location.query;
  return (
    <div className={styles.item} id={index}>
      <div className={styles.question}>
        { index }. { question }
      </div>
      <div className={styles.answer}>
        我的答案：{ userAnswer.map(i => numberMapChar[i]).join(', ') }
      </div>
      <div className={styles.answer}>
        正确答案：{ answer.map(i => numberMapChar[i]).join(', ') }
      </div>
      <div className={styles.desc}>
        <div className={styles.button}>
          <Link to={{
            pathname: `/${exam}/answer`,
            query: {
              ...query,
              page: index
            }
          }}>
            查看答案解析
          </Link>
        </div>
        {
          ['adaptation', 'smart'].indexOf(from) === -1 && <span>对答案有疑问？试试<span className={styles.bluespan} onClick={openConsult}>问问老师</span></span>
        }
      </div>
    </div>
  )
}

AnswerItem.propTypes = {
  index: PropTypes.number.isRequired,
  question: PropTypes.string.isRequired,
  answer: PropTypes.array.isRequired,
  userAnswer: PropTypes.array.isRequired
}

AnswerItem.contextTypes = {
  openConsult: PropTypes.func.isRequired
}

export default withRouter(AnswerItem)



/** WEBPACK FOOTER **
 ** ./src/components/Report/AnswerItem.js
 **/